import { useCrmLocale } from '../../ui/locale/crmLocale';
import { NavLink } from 'react-router-dom';
import { CalendarDays, Inbox, Mail, UserRound, WalletCards } from 'lucide-react';
import CrmNavigationSidebar from './CrmNavigationSidebar';
import WorkboardsEntry from '../../pages/marketing/workboards/WorkboardsEntry';

/** Existing authenticated employee routes for shared and standalone staff pages. */
export default function StaffNavigation() {
  const { t: crmText } = useCrmLocale();

  const items = [
    { path: '/employee/profile', en: 'Profile', ar: 'الملف الشخصي', icon: UserRound },
    { path: '/employee/messages', en: 'Messages', ar: 'الرسائل', icon: Inbox },
    { path: '/employee/mail', en: 'WorkMail', ar: 'البريد', icon: Mail },
    { path: '/employee/requests', en: 'Requests', ar: 'الطلبات', icon: WalletCards },
    { path: '/employee/attendance', en: 'Attendance', ar: 'الحضور', icon: CalendarDays },
  ];
  return <CrmNavigationSidebar label={crmText("Employee navigation")}><nav>
    <WorkboardsEntry />
    {items.map(({ path, en, icon: Icon }) => <NavLink key={path} to={path} aria-label={crmText(en)} title={crmText(en)}>
      <Icon size={18} /><span className="crm-nav-label">{crmText(en)}</span>
    </NavLink>)}
  </nav></CrmNavigationSidebar>;
}
